import { Request } from '../utilities/Request';

export function xero_authorize(this_obj) {
  return Request.get(this_obj, '/api/xero/authorize');
}

export function xero_callback(this_obj, code) {
  return Request.post(this_obj, '/api/xero/callback', null, { code });
}

export function xero_contacts(this_obj) {
  return Request.get(this_obj, '/api/xero/contacts');
}

export function xero_invoices(this_obj, contact_id) {
  return Request.post(this_obj, '/api/xero/invoices', null, { contact_id: contact_id });
}

export function xero_payments(this_obj, contact_id) {
  return Request.get(this_obj, '/api/xero/payments', null, { contact_id: contact_id });
}

export function xero_bills(this_obj, contact_id) {
  return Request.get(this_obj, '/api/xero/bills', null, { contact_id: contact_id });
}

export function xero_credit_notes(this_obj, contact_id) {
  return Request.get(this_obj, '/api/xero/credit_notes', null, { contact_id: contact_id });
}
export function truncate_xero_ids(this_obj) {
  return Request.post(this_obj, '/api/xero/truncate_xero_ids');
}
